module.exports = function(jss){return {};};